import React, { useState } from 'react';
import "../../styles/ReportCreation.css";
import ReportHeader from './ReportHeader';
import report_image from "../../assets/svg/report_image.svg";
import job_summary from "../../assets/svg/job_summary_icon.svg";
import job_type_breakdown from "../../assets/svg/job_type_icon.svg";
import con_vs_non_con from "../../assets/svg/con_vs_non-con_icon.svg";
import overall_financials from "../../assets/svg/overall_financials_icon.svg";
import sales_invoice from "../../assets/svg/sales_invoice_icon.svg";
import cost_invoice from "../../assets/svg/cost_invoice_icon.svg";
import project_summary from "../../assets/svg/project_summary_icon.svg";
import AsyncSelect from "react-select/async";
import axiosInstance from "../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import CommonFooter from '../../CommonFooter/CommonFooter';
import MultiSelectFilter from '../../CommonMultiSelectFilter/MultiSelectFilter';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ReportCreation = () => {
    const [selectedReport, setSelectedReport] = useState("");
    const [reportTypeOptions, setReportTypeOptions] = useState([]);
    const [isReportTypeDisabled, setIsReportTypeDisabled] = useState(false);
    const [selectedProject, setSelectedProject] = useState("");
    const [activeTab, setActiveTab] = useState("customized");
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedJobType, setSelectedJobType] = useState([]);
    const [plantCodeOptions, setPlantCodeOptions] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [isExporting, setIsExporting] = useState(false);
    const reportTypeMapping = {
        "Sales Accrual": "sales_accrual",
        "Cost Accrual": "cost_accrual",
        "Detailed Report": "detailed",
        "In-Detailed Report": "in_detailed",
        "Sap Consolidated Report": "sap_consolidated",
        "Sales Register" : "sales_register",
        "Revenue Register": "revenue_register",
        "Expense Register": "expense_register",
        "Job Summary": "job_summary",
        "Job Type Breakdown": "job_type_breakdown",
        "Contract vs Non-Contract Summary": "contract_non_contract_summary",
        "Sales Invoice Summary": "sales_invoice_summary",
        "Cost Invoice Summary": "cost_invoice_summary",
        "Overall Financials (Sales and Cost)": "overall_financials",
        "Summary": "summary",
        "Detailed": "detailed",
        "Sap Consolidated": "sap_consolidated"
    };
    const [selectedOptions, setSelectedOptions] = useState({
        reportType: "",
        project: "",
        jobStatus: "",
        customerBill: "",
        vendorBill: "",
        vendorName: ""
    });
    const [selectedReportType, setSelectedReportType] = useState('');
    const [selectedJobStatus, setSelectedJobStatus] = useState([]);
    const [selectedFromDate, setSelectedFromDate] = useState('');
    const [selectedToDate, setSelectedToDate] = useState('');
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [supplyPeriod, setSupplyPeriod] = useState("");
    const [selectedCustomerBillGeneration, setSelectedCustomerBillGeneration] = useState('');
    const [selectedVendorBillGeneration, setSelectedVendorBillGeneration] = useState('');

    const isSupplySelected = !!supplyPeriod;
    const isDateRangeSelected = !!selectedFromDate || !!selectedToDate;

    const handleReportChange = (e) => {
        const value = e.target.value;
        setSelectedReport(value);
        setSelectedReportType("");
        setSelectedJobStatus("");
        switch (value) {
            case "sales_accrual":
            case "cost_accrual":
                setReportTypeOptions(["Summary", "Detailed"]);
                setIsReportTypeDisabled(false);
                break;

            case "job":
                setReportTypeOptions(["Summary", "Detailed"]);
                setIsReportTypeDisabled(false);
                break;
            case "salesandcost":
                setReportTypeOptions(["Summary", "Detailed"]);
                setIsReportTypeDisabled(false);
                break;
            case "sales_invoice":
                setReportTypeOptions(["Sap Consolidated", "Detailed", "Revenue Register", "Sales Register"]);
                setIsReportTypeDisabled(false);
                break;

            case "cost_invoice":
                setReportTypeOptions(["Sap Consolidated", "Detailed", "Expense Register"]);
                setIsReportTypeDisabled(false);
                break;
            case "summary":
                setReportTypeOptions([
                    "Job Summary",
                    "Job Type Breakdown",
                    "Contract vs Non-Contract Summary",
                    "Sales Invoice Summary",
                    "Cost Invoice Summary",
                    "Overall Financials (Sales and Cost)"
                ]);
                setIsReportTypeDisabled(false);
                break;
            case "contract":
            case "accrual_vs_actual":
            case "salesandcost":
                setReportTypeOptions([]);
                setIsReportTypeDisabled(true);
                break;
            default:
                setReportTypeOptions([]);
                setIsReportTypeDisabled(false);
        }
    };

    const resetForm = () => {
        setSelectedReport("");
        setSelectedReportType("");
        setReportTypeOptions([]);
        setIsReportTypeDisabled(false);
        setSelectedOptions({
            reportType: "",
            project: "",
            jobStatus: "",
            customerBill: "",
            vendorBill: "",
            vendorName: ""
        });
        setSelectedProject(null);
        setSelectedJobStatus("");
        setSelectedFromDate("");
        setSelectedToDate("");
        setSelectedMonth(null);
        setSupplyPeriod("");
        setSelectedCustomerBillGeneration("");
        setSelectedVendorBillGeneration("");
        setSelectedVendor(null);
        setSelectedJobType([]);
        setPlantCodeOptions([]);
        setSelectedCategory(null);
    };

    const loadProjectOptions = async (inputValue, callback) => {

        try {
            const res = await axiosInstance.get("/costsolution/projects/autosuggestion", {
                params: { term: inputValue || '' },
            }
            );
            const projects = res.data?.autosuggestion || [];
            const filtered = projects.filter(item =>
                item.label.toUpperCase().includes(inputValue.toUpperCase())
            );
            const mapped = filtered.map((item) => ({
                label: item.label,
                value: item.value,
            }));
            console.log("Filtered + Mapped project options:", mapped);
            callback(mapped);
        } catch (error) {
            console.error("Project suggestion error:", error);
            callback([]);
        }
    };

    const loadVendorOptions = async (inputValue, callback) => {
        try {
            const res = await axiosInstance.get("/vendor/autosuggestion", {
                params: { term: inputValue || '' }
            });
            const data = res.data;
            if (data.success && Array.isArray(data.autosuggestion)) {
                const filtered = data.autosuggestion.filter(item =>
                    item.label.toUpperCase().includes(inputValue.toUpperCase())
                );

                const mapped = filtered.map((item) => ({
                    label: item.label,
                    value: item.value,
                }));

                console.log("Vendor search term:", inputValue);
                console.log("Filtered + Mapped vendor options:", mapped);
                callback(mapped);
            } else {
                callback([]);
            }
        } catch (error) {
            console.error("Vendor suggestion error:", error);
            callback([]);
        }
    };

    const handleExport = async () => {
        setIsExporting(true);

        const isInvoiceReport = selectedReport === "sales_invoice" || selectedReport === "cost_invoice";
        const isAccrualReport = selectedReport === "sales_accrual" || selectedReport === "cost_accrual";
        const statusField = isInvoiceReport ? "invoice_status" : isAccrualReport
            ? "accrual_status" : "job_status";

        if (!selectedReport) {
            toast.error("Please select a Report before exporting.");
            setIsExporting(false);
            return;
        }

        if (!selectedReportType && !isReportTypeDisabled) {
            toast.error("Please select a Report Type before exporting.");
            setIsExporting(false);
            return;
        }

        if (isAccrualReport && !selectedJobStatus) {
            toast.error("Please select the Accrual Status before exporting.");
            setIsExporting(false);
            return;
        }

        const payload = {
            report: selectedReport,
            report_type: reportTypeMapping[selectedReportType] || selectedReportType,
            project_id: selectedProject?.value || null,
            [statusField]: selectedJobStatus,
            from_date: selectedFromDate,
            to_date: selectedToDate,
            supply_period: supplyPeriod,
            customer_bill_generation: selectedCustomerBillGeneration,
            vendor_bill_generation: selectedVendorBillGeneration,
            vendor_id: selectedVendor?.value || null,
            job_type_id: selectedJobType.length
                ? selectedJobType.map(item => item.value)
                : null,

            plant_id: plantCodeOptions.length
                ? plantCodeOptions.map(item => item.value)
                : null,
            category: selectedCategory?.label || null
        };

        let filename = selectedReport.replace(/_/g, ' ');
        if (selectedReportType) {
            filename += ' ' + selectedReportType.replace(/_/g, ' ');
        }
        filename = filename
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
            + '-' + new Date().toISOString().split('T')[0] + '.xlsx';

        try {
            const response = await axiosInstance.post('/export_report', payload, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
            toast.success("Report exported successfully!");
        } catch (error) {
            console.error("Export failed:", error);
            toast.error("Failed to export report. Please try again.");
        } finally {
            setIsExporting(false);
        }
    };

    const loadJobTypes = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/jobtype/autosuggestion",
                {
                    params: { term: inputValue || '' },
                }
            );
            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadPlantCode = async (inputValue) => {
        try {
            const res = await axiosInstance.get(
                "/plant_code/autosuggestion",
                {
                    params: { term: inputValue || '' },
                }
            );
            return (res.data?.autosuggestion || []).map(p => ({
                label: p.label,
                value: p.value
            }));
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const loadCategories = async (inputValue, callback) => {
        try {
            const res = await axiosInstance.get("/charge/sapcode_autosuggestion", {
                params: { term: inputValue || '' },
            });
            const options = res.data?.autosuggestion || [];
            const mapped = options.map((item) => ({
                label: item.label,
                value: item.value,
            }));
            callback(mapped);
        } catch (error) {
            console.error("Categories suggestion error:", error);
            callback([]);
        }
    };

    const handleQuickReportExport = async (reportKey) => {
        setIsExporting(true);

        const payload = {
            report: 'summary',
            report_type: reportKey,
            from_date: selectedFromDate,
            to_date: selectedToDate,
            supply_period: supplyPeriod
        };

        try {
            const response = await axiosInstance.post('/export_report', payload, {
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${reportKey}_report.xlsx`;
            a.click();
            window.URL.revokeObjectURL(url);
            toast.success("Report exported successfully!");
        } catch (error) {
            console.error("Export failed:", error);
            toast.error("Failed to export report. Please try again.");
        } finally {
            setIsExporting(false);
        }
    };



    return (
        <>
            <ReportHeader onSearch={null} disableSearch={true} />
            <div className="report-container">
                <div className="report-left-section">
                    <h1 className="report-heading">
                        {activeTab === "customized" ? "Customizable Report" : "Quick Report"}
                    </h1>

                    <p className="report-description">
                        Access your data effortlessly with  {activeTab === "customized" ? "customizable" : "quick"} export options
                        streamline, optimize, & take control of your insights in just a
                        few clicks.
                    </p>
                    <img src={report_image} className="report-illustration" />
                </div>

                <div className="report-right-section">
                    <div className="report-tabs-container">
                        <button
                            className={`report-tab-button ${activeTab === "customized" ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab("customized");
                                resetForm();
                            }}
                        >
                            Customized
                        </button>
                        <button
                            className={`report-tab-button ${activeTab === "quick" ? "active" : ""}`}
                            onClick={() => {
                                setActiveTab("quick");
                                resetForm();
                            }}
                        >
                            Quick Report
                        </button>
                    </div>

                    {activeTab === "customized" ? (
                        <>
                            <h2 className="export-heading">Export your report</h2>

                            <div className="report-creation-form-grid">
                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Report  <span style={{ color: 'red' }}>*</span></label>
                                    <select
                                        className="report-creation-form-select"
                                        onChange={handleReportChange}
                                        value={selectedReport} >
                                        <option value="">Select</option>
                                        <option value="sales_accrual">Sales Accrual</option>
                                        <option value="cost_accrual">Cost Accrual</option>
                                        <option value="contract">Contract</option>
                                        <option value="job">Job</option>
                                        <option value="salesandcost">Sales and Cost</option>
                                        <option value="sales_invoice">Sales invoice</option>
                                        <option value="cost_invoice">Cost invoice</option>
                                        <option value="accrual_vs_actual">Accrual vs Actual</option>
                                        <option value="summary">Summary</option>
                                    </select>
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Report Type  <span style={{ color: 'red' }}>*</span></label>
                                    <div className="report-creation-select-wrapper">
                                        <select
                                            className="report-creation-form-select"
                                            disabled={isReportTypeDisabled}
                                            value={selectedReportType}
                                            onChange={(e) => setSelectedReportType(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {reportTypeOptions.map((type, idx) => (
                                                <option key={idx} value={type}>{type}</option>
                                            ))}
                                        </select>
                                    </div>

                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Project</label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadProjectOptions}
                                        onChange={setSelectedProject}
                                        value={selectedProject}
                                        placeholder="Search project..."
                                        isClearable
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                width: '100%',
                                                borderColor: state.isFocused ? '#454CF2' : '#e1e8ed',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': {
                                                    borderColor: '#454CF2'
                                                }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '13px'
                                            })

                                        }}
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">
                                        {selectedReport === "sales_invoice" || selectedReport === "cost_invoice"
                                            ? "Invoice status"
                                            : selectedReport === "sales_accrual" || selectedReport === "cost_accrual"
                                                ? <>Accrual status <span style={{ color: 'red' }}>*</span></>
                                                : "Job status"}
                                    </label>

                                    <select
                                        className="report-creation-form-select"
                                        value={selectedJobStatus}
                                        onChange={(e) => setSelectedJobStatus(e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        {selectedReport === "sales_invoice" || selectedReport === "cost_invoice" ? (
                                            <>
                                                <option value="draft">Draft</option>
                                                <option value="submitted">Submitted</option>
                                                <option value="sap pushed">SAP Pushed</option>
                                                <option value="final invoice">Final Invoice</option>
                                                <option value="deleted">Deleted Invoice</option>
                                            </>
                                        ) : selectedReport === "sales_accrual" || selectedReport === "cost_accrual" ? (
                                            <>
                                                <option value="open">Open</option>
                                                <option value="closed">Closed</option>
                                            </>
                                        ) : (
                                            <>
                                                <option value="draft">Draft</option>
                                                <option value="submitted">Submitted</option>
                                                <option value="partially invoiced">Partially Invoiced</option>
                                                <option value="completed">Completed</option>
                                            </>
                                        )}
                                    </select>

                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">
                                        Supply Period
                                    </label>

                                    <DatePicker
                                        selected={selectedMonth}
                                        disabled={isDateRangeSelected}
                                        onChange={(date) => {
                                            if (!date) {
                                                setSelectedMonth(null);
                                                setSupplyPeriod("");
                                                return;
                                            }
                                            setSelectedFromDate("");
                                            setSelectedToDate("");
                                            setSelectedMonth(date);

                                            const monthYear = date
                                                .toLocaleString("default", {
                                                    month: "short",
                                                    year: "numeric",
                                                })
                                                .replace(" ", "-");

                                            setSupplyPeriod(monthYear);
                                        }}
                                        dateFormat="MMM-yyyy"
                                        showMonthYearPicker
                                        isClearable
                                        placeholderText="MMM-YYYY"
                                        className="report-creation-form-supply-period-input"
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">
                                        Date Range
                                    </label>

                                    <DatePicker
                                        disabled={isSupplySelected}
                                        selectsRange
                                        startDate={
                                            selectedFromDate
                                                ? new Date(selectedFromDate)
                                                : null
                                        }
                                        endDate={
                                            selectedToDate
                                                ? new Date(selectedToDate)
                                                : null
                                        }
                                        onChange={(update) => {
                                            const [start, end] = update;

                                            const formatDate = (date) => {
                                                if (!date) return "";
                                                const year = date.getFullYear();
                                                const month = String(date.getMonth() + 1).padStart(2, "0");
                                                const day = String(date.getDate()).padStart(2, "0");
                                                return `${year}-${month}-${day}`;
                                            };

                                            setSelectedMonth(null);
                                            setSupplyPeriod("");

                                            setSelectedFromDate(formatDate(start));
                                            setSelectedToDate(formatDate(end));
                                        }}
                                        isClearable
                                        placeholderText="Select date range"
                                        dateFormat="dd-MM-yyyy"
                                        className="report-creation-form-supply-period-input"
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <MultiSelectFilter
                                        label="Job Type"
                                        value={selectedJobType}
                                        onChange={setSelectedJobType}
                                        loadOptions={loadJobTypes}
                                        placeholder="Select Job Type"
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                borderColor: state.isFocused ? '#454CF2' : '#e1e8ed',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': { borderColor: '#454CF2' }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: "100%",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: "220px",
                                                overflowY: "auto",
                                            }),
                                        }}
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <MultiSelectFilter
                                        label="Plant Code"
                                        value={plantCodeOptions}
                                        onChange={setPlantCodeOptions}
                                        loadOptions={loadPlantCode}
                                        placeholder="Select Plant Code"
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                borderColor: state.isFocused ? '#454CF2' : '#e1e8ed',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': { borderColor: '#454CF2' }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: "100%",
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: "12px",
                                            }),
                                            menuList: (base) => ({
                                                ...base,
                                                maxHeight: "220px",
                                                overflowY: "auto",
                                            }),
                                        }}
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Category</label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadCategories}
                                        onChange={setSelectedCategory}
                                        value={selectedCategory}
                                        placeholder="Select category..."
                                        isClearable
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                width: '100%',
                                                borderColor: state.isFocused ? '#454CF2' : '#e1e8ed',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': {
                                                    borderColor: '#454CF2'
                                                }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '13px'
                                            })
                                        }}
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Vendor name</label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadVendorOptions}
                                        onChange={setSelectedVendor}
                                        value={selectedVendor}
                                        placeholder="Search vendor..."
                                        isClearable
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '40px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                width: '100%',
                                                borderColor: state.isFocused ? '#454CF2' : '#e1e8ed',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': {
                                                    borderColor: '#454CF2'
                                                }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                fontSize: '13px'
                                            })
                                        }}
                                    />
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Customer bill generation</label>
                                    <select className="report-creation-form-select" value={selectedCustomerBillGeneration}
                                        onChange={(e) => setSelectedCustomerBillGeneration(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="not_generated">Not Generated</option>
                                        <option value="partially_generated">Partially Generated</option>
                                        <option value="bill_generated">Bill Generated</option>
                                    </select>
                                </div>

                                <div className="report-creation-form-group">
                                    <label className="report-creation-form-label">Vendor bill generation</label>
                                    <select className="report-creation-form-select" value={selectedVendorBillGeneration}
                                        onChange={(e) => setSelectedVendorBillGeneration(e.target.value)}>
                                        <option value="">Select</option>
                                        <option value="not_generated">Not Generated</option>
                                        <option value="partially_generated">Partially Generated</option>
                                        <option value="bill_generated">Bill Generated</option>
                                    </select>
                                </div>
                            </div>

                            <div className="report-creation-form-actions">
                                <button className="report-creation-btn btn-reset" onClick={resetForm}>Reset</button>
                                <button className="report-creation-btn btn-export" onClick={handleExport} disabled={isExporting}>{isExporting ? 'Exporting...' : 'Export'}</button>
                            </div>
                        </>
                    ) : (
                        <div className="quick-report-container">
                            <p className="quick-report-subtitle">
                                <span>Just a single click is enough!</span>
                            </p>
                            <div className="quick-report-date quick-report-filter-grid">
                                <div className="quick-report-field">
                                    <p className="date-range">Supply Period :</p>

                                    <DatePicker
                                        selected={selectedMonth}
                                        onChange={(date) => {
                                            if (!date) {
                                                setSelectedMonth(null);
                                                setSupplyPeriod("");
                                                return;
                                            }

                                            setSelectedMonth(date);

                                            const monthYear = date
                                                .toLocaleString("default", {
                                                    month: "short",
                                                    year: "numeric",
                                                })
                                                .replace(" ", "-");

                                            setSupplyPeriod(monthYear);
                                        }}
                                        dateFormat="MMM-yyyy"
                                        showMonthYearPicker
                                        isClearable
                                        placeholderText="MMM-YYYY"
                                        className="report-creation-form-input"
                                    />
                                </div>

                                {/* Date Range */}
                                <div className="quick-report-field">
                                    <p className="date-range">Date Range :</p>

                                    <DatePicker
                                        selectsRange
                                        startDate={
                                            selectedFromDate
                                                ? new Date(selectedFromDate)
                                                : null
                                        }
                                        endDate={
                                            selectedToDate
                                                ? new Date(selectedToDate)
                                                : null
                                        }
                                        onChange={(update) => {
                                            const [start, end] = update;

                                            const formatDate = (date) => {
                                                if (!date) return "";
                                                const year = date.getFullYear();
                                                const month = String(date.getMonth() + 1).padStart(2, "0");
                                                const day = String(date.getDate()).padStart(2, "0");
                                                return `${year}-${month}-${day}`;
                                            };

                                            setSelectedFromDate(formatDate(start));
                                            setSelectedToDate(formatDate(end));
                                        }}
                                        isClearable
                                        placeholderText="Select date range"
                                        dateFormat="dd-MM-yyyy"
                                        className="report-creation-form-input"
                                    />
                                </div>
                            </div>

                            <div className="quick-report-grid">
                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('job_summary')}
                                >
                                    <img src={job_summary} alt="Job summary" />
                                    <span>Job summary</span>
                                </button>

                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('job_type_breakdown')}
                                >
                                    <img src={job_type_breakdown} alt="Job type breakdown" />
                                    <span>Job type breakdown</span>
                                </button>

                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('contract_non_contract_summary')}
                                >
                                    <img src={con_vs_non_con} alt="Contract vs Non-contract" />
                                    <span>Contract vs Non-contract</span>
                                </button>

                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('overall_financials')}
                                >
                                    <img src={overall_financials} alt="Overall financials" />
                                    <span>Overall financials</span>
                                </button>

                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('sales_invoice_summary')}
                                >
                                    <img src={sales_invoice} alt="Sales invoice" />
                                    <span>Sales invoice</span>
                                </button>

                                <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('cost_invoice_summary')}
                                >
                                    <img src={cost_invoice} alt="Cost invoice" />
                                    <span>Cost invoice</span>
                                </button>

                                {/* <button
                                    type="button"
                                    className="quick-report-card"
                                    onClick={() => handleQuickReportExport('summary')}
                                >
                                    <img src={project_summary} alt="Project summary" />
                                    <span>Project summary</span>
                                </button> */}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
        </>
    );
};

export default ReportCreation;
